import { useNavigate } from "react-router-dom";
import useTranslator from "../../hooks/useTranslator";
import { Button, Icon, Modal, Select } from "../design";
import styles from "./ConnectBankModal.module.css";

// Markets Tink supports for the bank report
const COUNTRIES = [
  ["BE", "belgium"],
  ["DE", "germany"],
  ["DK", "denmark"],
  ["EE", "estonia"],
  ["ES", "spain"],
  ["FI", "finland"],
  ["FR", "france"],
  ["GB", "unitedKingdom"],
  ["IT", "italy"],
  ["LT", "lithuania"],
  ["LV", "latvia"],
  ["NL", "netherlands"],
  ["NO", "norway"],
  ["PL", "poland"],
  ["PT", "portugal"],
  ["SE", "sweden"],
];

/**
 * "Connect your bank": Tink explained on a dark panel, then pick the bank's
 * country and go to Tink.
 * Used in onboarding (BankModal) and in tenant checks (UserSpecificIncomeModel).
 */
const ConnectBankModal = ({
  open,
  onClose,
  title,
  buttonLabel,
  country,
  onCountryChange,
  error,
  onConnect,
  loading = false,
  // the popup sits inside a clickable overlay in some flows
  stopClicks = false,
}) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();

  const content = (
    <div className={styles.layout}>
      <aside className={styles.tink}>
        <p>
          {_t(
            "youWillNowBeRedirectedToConnectYourBankAccountThroughOurPartnerTinkPoweredByVisa"
          )}
        </p>
        <p>
          {_t(
            "itsImportantForYouToKnowThatWeDoNotHaveDirectAccessToYourBankLoginDetails"
          )}{" "}
          {_t(
            "thisProcessIsDesignedToMaintainYourCredentialsEncriptedFromSkorOrAnyOtherThirdParty"
          )}
        </p>
        <img
          className={styles.tinkImage}
          src="/images/connect_bank.svg"
          alt="Tink, a Visa solution"
        />
        <p className={styles.tinkNote}>
          <Icon name="shieldCheck" size={16} />
          {_t("weAssureYouOfTheUtmostPrivacyAndSecurityOfYourFinancialData")}
        </p>
      </aside>

      <div className={styles.form}>
        <h2 className={styles.title}>{title}</h2>
        <Select
          id="tink-country"
          label={_t("country")}
          placeholder={_t("selectYourCountry")}
          value={country}
          onChange={onCountryChange}
          error={error}
          options={COUNTRIES.map(([value, key]) => ({
            value,
            label: _t(key),
          }))}
        />
        <Button
          size="lg"
          block
          loading={loading}
          iconStart={<Icon name="building" />}
          onClick={onConnect}
        >
          {buttonLabel}
        </Button>
        <p className={styles.help}>
          {_t("shouldYouHaveAnyConcernsOrQuestionsPlease")}{" "}
          <Button variant="link" onClick={() => navigate("/bank")}>
            {_t("readHere")}
          </Button>{" "}
          {_t("orContactUsAt")}{" "}
          <a href="mailto:info@skortorent.com">info@skortorent.com</a>
        </p>
      </div>
    </div>
  );

  const modal = (
    <Modal open={open} onClose={onClose} size="lg" align="start">
      {content}
    </Modal>
  );

  // React passes clicks from the portal up to the parent overlay; stop them
  return stopClicks ? (
    <div onClick={(event) => event.stopPropagation()}>{modal}</div>
  ) : (
    modal
  );
};

export default ConnectBankModal;
